import { EntityManager } from "@/components/EntityManager";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function Transfers() {
  return <EntityManager config={ENTITY_CONFIG.transfers} />;
}
